module.exports = __webpack_public_path__ + "static/image-01-a@2x-787f1bc2674c72bf879db1298beb9b82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/yieldr/image-01-a@2x.jpg
// module id = 424
// module chunks = 3627797113349 20562973939449 33019919093843